import { ajaxRequest } from "../Ajax/ajax";
import { makeModal } from "../utils";
import { rerenderTask } from "./rerenderTask";


export function loadSingleTaskFunctionality(){

    $(document).on("click", ".show-single-task", function(){
        const taskId = Number($(this).attr('data-aufgabe'))
        loadSingleTask(taskId, $(this))
    })

}

export function loadSingleTask(taskId, btn:boolean|JQuery=false){

    const url = '/task/' + taskId.toString() + '/load'

    const success = function (data){
        const modal = makeModal('single-task', 'Aufgabe ansehen', data.html, {}, true, 'xl');
        modal.show();
        rerenderTask()
    }

    ajaxRequest(url, success, {}, btn)
  }